import { Controller } from "@hotwired/stimulus"

// Provides a styled file upload with optional auto-submit on selection.
//
// Usage:
//   <div data-controller="file-upload" data-file-upload-auto-submit-value="true">
//     <input type="file" data-file-upload-target="input"
//            data-action="change->file-upload#fileSelected" class="hidden">
//     <button data-file-upload-target="dropZone"
//             data-action="click->file-upload#browse ...">Upload</button>
//     <span data-file-upload-target="status" class="hidden"></span>
//   </div>
export default class extends Controller {
  static targets = ["input", "dropZone", "status"]
  static values = { autoSubmit: { type: Boolean, default: false } }

  browse(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  fileSelected() {
    if (this.inputTarget.files?.length > 0) {
      this.#submit()
    }
  }

  dragOver(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add("btn-primary")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove("btn-primary")
  }

  drop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove("btn-primary")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.#submit()
    }
  }

  #submit() {
    if (this.autoSubmitValue) {
      this.#showUploading()
      this.inputTarget.closest("form").requestSubmit()
    }
  }

  #showUploading() {
    if (this.hasDropZoneTarget) this.dropZoneTarget.classList.add("hidden")
    if (this.hasStatusTarget) {
      this.statusTarget.classList.remove("hidden")
      this.statusTarget.textContent = "Uploading\u2026"
    }
  }
}
